//  post survey
export const REQUEST_PHASE_SURVEY = "REQUEST_PHASE_SURVEY";
export const RECEIVE_PHASE_SURVEY ="RECEIVE_PHASE_SURVEY";